-<template>
  <div id="viewProducthistoricalDetails">
    <vs-popup id="viewProducthistoricalDetails" title="Product Historical Details " button-accept="false" button-cancel="false" :active.sync="isActive">
      <div class="adjustment__details">
        <div class="adjustment__reason flex mb-2">
          <div class="flex">
            <p class="font-medium flex items-center reason-div-width">Adjustment Reason :</p>
            <div class="ml-2">{{ viewProducthistoricalDetail.reason }}</div>
          </div>
        </div>

        <div class="adjustment__note flex">
          <div class="flex">
            <p class="font-medium flex items-center reason-div-width">Adjustment Note :</p>
            <div class="ml-2">{{ viewProducthistoricalDetail.notes }}</div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  name: 'ViewProductHistoricalDetails',

  props: {
    showModal: Boolean,
    viewProducthistoricalDetail: Object
  },
  data: () => ({
    reason: '',
    notes: ''
  }),

  computed: {
    // close the poup
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    }
  }
}
</script>
<style scoped>
.reason-div-width {
  min-width: 160px;
  /* width: 100%; */
}
</style>